module.exports = __webpack_public_path__ + "media/images/lion-black-6bc241f2d43098ab65e5d49712cfbc42.png";